module.exports = __webpack_public_path__ + "static/media/background-3.1e73342c.svg";